import * as qc from "../ApiEndPoints.js";
import { axiosGetFileAuthorizeblob, axiosGetMultiParams, axiosGetWithencryption, axiosPostWithencryption } from "../AxiosRequests.js";

export default class QCServices {

    // Raw Material Sample Entry
    async getRawMaterialSampleEntryCount(request) {
        return axiosGetWithencryption(qc.GetRawMaterialSampleEntryCount, request);
    }

    async getGRNItemsByGRNNo(request) {
        return axiosGetMultiParams(qc.GetGRNItemsByGRNNo, request);
    }

    async addEditRawMaterialSampleEntry(request) {
        return axiosPostWithencryption(qc.AddEditRawMaterialSampleEntry, request);
    }

    async getAllRawMaterialSampleEntry(request) {
        return axiosGetMultiParams(qc.GetAllRawMaterialSampleEntry, request);
    }

    async getRawMaterialSampleEntryDetailsById(request) {
        return axiosGetWithencryption(qc.GetRawMaterialSampleEntryDetailsById, request);
    }

    async deleteRawMaterialSampleEntryById(request) {
        return axiosGetWithencryption(qc.DeleteRawMaterialSampleEntryById, request);
    }

    async generateSampleEntryRmReport(request) {
        return axiosGetFileAuthorizeblob(qc.GenerateSampleEntryRmReport, request);
    }

    // Packing Material Sample Entry
    async getPackingMaterialSampleEntryCount(request) {
        return axiosGetWithencryption(qc.GetPackingMaterialSampleEntryCount, request);
    }

    async addEditPackingMaterialSampleEntry(request) {
        return axiosPostWithencryption(qc.AddEditPackingMaterialSampleEntry, request);
    }

    async getAllPackingMaterialSampleEntry(request) {
        return axiosGetMultiParams(qc.GetAllPackingMaterialSampleEntry, request);
    }

    async getPackingMaterialSampleEntryDetailsById(request) {
        return axiosGetWithencryption(qc.GetPackingMaterialSampleEntryDetailsById, request);
    }

    async deletePackingMaterialSampleEntryById(request) {
        return axiosGetWithencryption(qc.DeletePackingMaterialSampleEntryById, request);
    }
    async generateSampleEntryPmReport(request) {
        return axiosGetFileAuthorizeblob(qc.GenerateSampleEntryPmReport, request);
    }

    // Finish Goods Sample Entry
    async getFinishGoodsSampleEntryCount(request) {
        return axiosGetWithencryption(qc.GetFinishGoodsSampleEntryCount, request);
    }

    async getProductionItemsByProductionNo(request) {
        return axiosGetMultiParams(qc.GetProductionItemsByProductionNo, request);
    }

    async addEditFinishGoodsSampleEntry(request) {
        return axiosPostWithencryption(qc.AddEditFinishGoodsSampleEntry, request);
    }

    async getAllFinishGoodsSampleEntry(request) {
        return axiosGetMultiParams(qc.GetAllFinishGoodsSampleEntry, request);
    }

    async getFinishGoodsSampleEntryDetailsById(request) {
        return axiosGetWithencryption(qc.GetFinishGoodsSampleEntryDetailsById, request);
    }

    async deleteFinishGoodsSampleEntryById(request) {
        return axiosGetWithencryption(qc.DeleteFinishGoodsSampleEntryById, request);
    }

    async generateSampleEntryFGReport(request) {
        return axiosGetFileAuthorizeblob(qc.GenerateSampleEntryFGReport, request);
    }

    // Raw Material Test Report Entry
    async getAllPeningRawMaterialSampleEntry(request) {
        return axiosGetMultiParams(qc.GetAllPeningRawMaterialSampleEntry, request);
    }

    async addEditRawMaterialTestReport(request) {
        return axiosPostWithencryption(qc.AddEditRawMaterialTestReport, request);
    }

    async getAllRawMaterialTestReportEntry(request) {
        return axiosGetMultiParams(qc.GetAllRawMaterialTestReportEntry, request);
    }

    async getRawMaterialTestEntryDetailsById(request) {
        return axiosGetWithencryption(qc.GetRawMaterialTestEntryDetailsById, request);
    }

    async deleteRawMaterialTestEntryById(request) {
        return axiosGetWithencryption(qc.DeleteRawMaterialTestEntryById, request);
    }

    async generateTestingEntryRmReport(request) {
        return axiosGetFileAuthorizeblob(qc.GenerateTestingEntryRmReport, request);
    }

    // Packing Material Test Report Entry
    async getAllPeningPackingMaterialSampleEntry(request) {
        return axiosGetMultiParams(qc.GetAllPeningPackingMaterialSampleEntry, request);
    }

    async addEditPackingMaterialTestReport(request) {
        return axiosPostWithencryption(qc.AddEditPackingMaterialTestReport, request);
    }

    async getAllPackingMaterialTestReportEntry(request) {
        return axiosGetMultiParams(qc.GetAllPackingMaterialTestReportEntry, request);
    }

    async getPackingMaterialTestEntryDetailsById(request) {
        return axiosGetWithencryption(qc.GetPackingMaterialTestEntryDetailsById, request);
    }

    async deletePackingMaterialTestEntryById(request) {
        return axiosGetWithencryption(qc.DeletePackingMaterialTestEntryById, request);
    }

    async generateTestingEntryPmReport(request) {
        return axiosGetFileAuthorizeblob(qc.GenerateTestingEntryPmReport, request);
    }

    // Finish Goods Test Report Entry
    async getAllPeningFinishGoodsSampleEntry(request) {
        return axiosGetMultiParams(qc.GetAllPeningFinishGoodsSampleEntry, request);
    }

    async addEditFinishGoodsTestReport(request) {
        return axiosPostWithencryption(qc.AddEditFinishGoodsTestReport, request);
    }

    async getAllFinishGoodsTestReportEntry(request) {
        return axiosGetMultiParams(qc.GetAllFinishGoodsTestReportEntry, request);
    }

    async getFinishGoodsTestEntryDetailsById(request) {
        return axiosGetWithencryption(qc.GetFinishGoodsTestEntryDetailsById, request);
    }

    async deleteFinishGoodsTestEntryById(request) {
        return axiosGetWithencryption(qc.DeleteFinishGoodsTestEntryById, request);
    }

    async generateTestingEntryFGReport(request) {
        return axiosGetFileAuthorizeblob(qc.GenerateTestingEntryFGReport, request);
    }
}

